import React from 'react';

import {Field} from 'redux-form';

import Table from 'components/Table';
import Money from 'components/Money';
import {SearchField, NumberField, TextField} from 'components/Fields';

import {required} from 'utils/validators';

import './styles.css';

const ItemFields = ({xeroTaxRates, lineAmount}) => (
  <div className="ItemFields">
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Description" className="description" />
        <Table.HeaderItem heading="QTY" className="quantity" />
        <Table.HeaderItem heading="Unit price (£)" className="unitPrice" />
        <Table.HeaderItem heading="Discount %" className="discount" />
        <Table.HeaderItem heading="Tax rate" className="taxRate" />
        <Table.HeaderItem heading="Amount" className="amount" />
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Field
              className="description"
              name="description"
              type="input"
              validate={[required]}
              component={TextField}
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="quantity"
              name="quantity"
              validate={[required]}
              component={NumberField}
              min="1"
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="unitPrice"
              name="unitPrice"
              validate={[required]}
              component={NumberField}
              step="0.01"
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="discount"
              name="discount"
              validate={[required]}
              component={NumberField}
              step="0.01"
            />
          </Table.Cell>
          <Table.Cell>
            <Field
              className="taxRate"
              name="taxRate"
              type="select"
              placeholder="Select account ..."
              validate={[required]}
              component={SearchField}
              options={xeroTaxRates.map(tax => ({
                value: tax.id,
                label: tax.name,
                effectiveRate: tax.effectiveRate
              }))}
              disabled={xeroTaxRates.length <= 1}
            />
          </Table.Cell>
          <Table.Cell>
            {!isNaN(lineAmount) && (
              <div className="lineAmount">
                <Money amount={lineAmount} />
              </div>
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </div>
);

export default ItemFields;
